import Text from '../Text';
import NumberedList from './styled';

export function NumberedListItem({ children }) {
  return (
    <li>
      <Text variant="sub400" color="neutral" as="span">
        {children}
      </Text>
    </li>
  );
}

export default NumberedList;
